export default [
    {
        tenantId: '999999999',
        userId: '999999999',
        issueId: '999999999',
        id: '62',
        uuid: '90cf6e49-6a43-4df1-888d-4c90c6aad718',
        color: '#ff4081',
        startPage: null,
        startPageStartOffset: null,
        startPageLength: null,
        endPage: null,
        endPageLength: null,
        totalLength: 46,
        totalText: "The Geography of Bliss: One Grump's Search for the Happiest Places",
        epubLocationStartChar: '1',
        epubLocation: { chapterHref: 'xtoc', cfi: '/4/2,/1:0,/1:46' },
        epubChapter: 'xtoc',
        epubLocationEndCfi: '/4/4/50/26/2/1:32',
        epubLocationStartCfi: '/4/2/1:0',
        createdAt: '2019-03-21 21:34:59',
        updatedAt: '2019-03-21 21:35:03',
    },
    {
        tenantId: '999999999',
        userId: '999999999',
        issueId: '999999999',
        id: '63',
        uuid: '35a90da9-26ad-418b-89ad-87b86d28d5f2',
        color: '#ff5722',
        startPage: null,
        startPageStartOffset: null,
        startPageLength: null,
        endPage: null,
        endPageLength: null,
        totalLength: 11,
        totalText: 'of Contents',
        epubLocationStartChar: '56',
        epubLocation: { chapterHref: 'xtoc', cfi: '/4/4/2/2,/1:6,/1:17' },
        epubChapter: 'xtoc',
        epubLocationEndCfi: '/4/4/50/26/2/1:32',
        epubLocationStartCfi: '/4/2/2/1:0',
        createdAt: '2019-03-21 21:35:08',
        updatedAt: '2019-03-21 21:35:08',
    },
    {
        tenantId: '999999999',
        userId: '999999999',
        issueId: '999999999',
        id: '64',
        uuid: 'd1c1e13a-6a25-44fb-9de3-72302868ecdf',
        color: '#03a9f4',
        startPage: null,
        startPageStartOffset: null,
        startPageLength: null,
        endPage: null,
        endPageLength: null,
        totalLength: 4,
        totalText: 'oduc',
        epubLocationStartChar: '16',
        epubLocation: {
            chapterHref: 'x03_9781119998952-intro',
            cfi: '/4/2[x03_9781119998952-intro.html]/2/2[a1]/1:4',
        },
        epubChapter: 'x03_9781119998952-intro',
        epubLocationEndCfi: '/4/2[x03_9781119998952-intro.html]/2/78/3:1',
        epubLocationStartCfi: '/4/2[x03_9781119998952-intro.html]/2/2[a1]/1:0',
        createdAt: '2019-03-21 21:35:18',
        updatedAt: '2019-03-21 21:35:18',
    },
    {
        tenantId: '999999999',
        userId: '999999999',
        issueId: '999999999',
        id: '65',
        uuid: '6fc864e8-865c-44a8-9ca7-f5db21ce48d9',
        color: '#ffeb3b',
        startPage: null,
        startPageStartOffset: null,
        startPageLength: null,
        endPage: null,
        endPageLength: null,
        totalLength: 198,
        totalText:
            'No matter how many times I asked, I was always told the same thing: \u201cWhen you grow up and get a job, you\u2019ll need to be able to communicate clearly. You need good handwriting to communicate clearly.\u201d',
        epubLocationStartChar: '687',
        epubLocation: {
            chapterHref: 'x03_9781119998952-intro',
            cfi: '/4/2[x03_9781119998952-intro.html]/2/8/0',
        },
        epubChapter: 'x03_9781119998952-intro',
        epubLocationEndCfi: '/4/2[x03_9781119998952-intro.html]/2/78/3:1',
        epubLocationStartCfi: '/4/2[x03_9781119998952-intro.html]/2/2[a1]/1:0',
        createdAt: '2019-03-21 21:35:22',
        updatedAt: '2019-03-21 21:35:22',
    },
    {
        tenantId: '999999999',
        userId: '999999999',
        issueId: '999999999',
        id: '66',
        uuid: 'b1762a3c-d608-414b-a589-cc08e4ae2712',
        color: '#ff5722',
        startPage: null,
        startPageStartOffset: null,
        startPageLength: null,
        endPage: null,
        endPageLength: null,
        totalLength: 677,
        totalText:
            'Today\u2019s world is, of course, vastly different. Not only can most of us read and write, but we don\u2019t even have to worry about our handwriting. Desktop publishing, and even the ability to publish on the Internet, is available to the majority of people in the industrialized world.\n\nNot only can we publish our words, but we can design them. We have access to thousands of fonts. We can change colors and sizes of fonts with a few clicks. We can edit and publish photos and illustrations alongside our words.\n\nWe\u2019re all modern-day printers. We can create flyers, postcards, and PowerPoint presentations complete with animations. We can create blogs, posters, and even coffee mugs.',
        epubLocationStartChar: '4629',
        epubLocation: {
            chapterHref: 'x03_9781119998952-intro',
            cfi: '/4/2[x03_9781119998952-intro.html]/2,/28/1:0,/32/1:170',
        },
        epubChapter: 'x03_9781119998952-intro',
        epubLocationEndCfi: '/4/2[x03_9781119998952-intro.html]/2/78/3:1',
        epubLocationStartCfi: '/4/2[x03_9781119998952-intro.html]/2/2[a1]/1:0',
        createdAt: '2019-03-21 21:35:28',
        updatedAt: '2019-03-21 21:35:36',
    },
    {
        tenantId: '999999999',
        userId: '999999999',
        issueId: '999999999',
        id: '67',
        uuid: 'ced45039-3e35-43a8-a9c6-1939f136525a',
        color: '#ff5722',
        startPage: null,
        startPageStartOffset: null,
        startPageLength: null,
        endPage: null,
        endPageLength: null,
        totalLength: 551,
        totalText:
            'I\u2019ve implemented the fruits of all this practice and analysis in the fast-paced environment of Silicon Valley startups. Design and visual communication is so deeply embedded in my brain that I\u2019m hardly aware of its presence. My handwriting still sucks, though.\n\nDesign as Literacy\n\nOne evening, I was \u201cmoworking\u201d in a cafe with my friend Ziad, coding some design tweaks to the WordPress template for my blog. Ziad always has a way of saying abstract things that break my concentration and split my brain wide open, and this evening was no exception:',
        epubLocationStartChar: '2069',
        epubLocation: {
            chapterHref: 'x03_9781119998952-intro',
            cfi: '/4/2[x03_9781119998952-intro.html]/2,/14/1:579,/18/1:268',
        },
        epubChapter: 'x03_9781119998952-intro',
        epubLocationEndCfi: '/4/2[x03_9781119998952-intro.html]/2/82/3:1',
        epubLocationStartCfi: '/4/2[x03_9781119998952-intro.html]/2/2[a1]/1:0',
        createdAt: '2019-03-21 21:35:41',
        updatedAt: '2019-03-21 21:35:41',
    },
];
